import React, { useEffect, useMemo, useState, useRef } from 'react';
import { Typography, Box, Paper, IconButton } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate, useParams } from 'react-router-dom';
import MessageInput from '../../components/Inbox/MessageInput';
import ChatMessagePanel from '../../components/Inbox/ChatMessagePanel';
import { sendMessageApi } from '../../api';

const ChatRoom = () => {
  const navigate = useNavigate();
  const { roomId } = useParams();

  const currentUser = useMemo(() => {
    try {
      return JSON.parse(window.localStorage.getItem('currentUser') || 'null');
    } catch (e) {
      return null;
    }
  }, []);
  const currentUserId = currentUser?.userId || null;
  const currentUserRole = currentUser?.role || null;

  const [viewportHeight, setViewportHeight] = useState(() => {
    if (typeof window === 'undefined') return null;
    return window.visualViewport?.height || window.innerHeight || null;
  });
  const [viewportVersion, setViewportVersion] = useState(0);
  const messagesContainerRef = useRef(null);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const updateHeight = () => {
      if (typeof window === 'undefined') return;
      const next = window.visualViewport?.height || window.innerHeight || null;
      setViewportHeight(next);
      setViewportVersion((prev) => prev + 1);
    };

    updateHeight();
    window.addEventListener('resize', updateHeight);
    window.visualViewport?.addEventListener?.('resize', updateHeight);

    return () => {
      window.removeEventListener('resize', updateHeight);
      window.visualViewport?.removeEventListener?.('resize', updateHeight);
    };
  }, []);

  const containerHeight = viewportHeight ? `${viewportHeight}px` : '100dvh';

  const handleBack = () => {
    navigate(-1);
  };

  const handleSend = async (content) => {
    try {
      await sendMessageApi(roomId, content);
    } catch (e) {
      console.error(e);
      if (e?.status === 401 || e?.suppressAlert) return;
      alert('메시지 전송 실패');
    }
  };

  return (
    <Box>
      <Box
        sx={{
          maxWidth: 430,
          mx: 'auto',
          bgcolor: 'white',
          height: containerHeight,
          minHeight: containerHeight,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 0,
          boxShadow: '0 0 20px rgba(0,0,0,0.06)',
          px: 2,
          position: 'relative',
          pt: 'env(safe-area-inset-top)',
          pb: 'env(safe-area-inset-bottom)',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            height: 60,
            borderBottom: '1px solid #e0e0e0',
            mb: 0,
            mx: -2,
            px: 2,
            position: 'relative',
          }}
        >
          <IconButton onClick={handleBack} sx={{ p: 0, position: 'absolute', left: 16 }}>
            <ArrowBackIosNewIcon sx={{ fontSize: 20, color: '#333' }} />
          </IconButton>
          <Typography
            sx={{
              flex: 1,
              textAlign: 'center',
              fontSize: 18,
              fontWeight: 700,
            }}
          >
            1:1문의
          </Typography>
        </Box>

        <Paper
          elevation={0}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minHeight: 0,
          }}
        >
          <Box
            sx={{
              flex: 1,
              p: 2,
              overflowY: 'auto',
              bgcolor: 'white',
              minHeight: 0,
            }}
            ref={messagesContainerRef}
          >
            <ChatMessagePanel
              roomId={roomId}
              currentUserId={currentUserId}
              currentUserRole={currentUserRole}
              viewportVersion={viewportVersion}
              scrollContainerRef={messagesContainerRef}
            />
          </Box>
          <Box sx={{ mt: 1.5, flexShrink: 0 }}>
            <MessageInput onSend={handleSend} />
          </Box>
        </Paper>
      </Box>
    </Box>
  );
};

export default ChatRoom;


